exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-drawer h2.drawer-header {\n  font-size: 24px !important;\n}\n.custom-drawer .ant-drawer-content {\n  border-radius: 8px 0 0 8px;\n}\n.ant-drawer-content-wrapper {\n  max-width: 100vw;\n}", ""]);

// exports
